import colors from "../../../appConfig/colors";
import { makeStyles } from "@material-ui/core/styles";

const AppStyle = makeStyles((theme) => ({
	header: {
		overflow: "hidden",
		boxShadow:
			"0px 5px 5px -9px rgb(0 0 0 / 10%), 0px -2px 10px 1px rgb(0 0 0 / 14%), 0px 3px 14px 2px rgb(0 0 0 / 12%)",
		backgroundColor: colors.veryLightGray,
		borderBottom: `1px solid ${colors.gainsboroLike}`,
	},
	body: {
		height: "calc(100% - 90px)",
	},
	loaderContainer: {
		height: "100%",
		paddingTop: "10%",
		flexDirection: "column",
	},
	loader: {
		color: colors.primary,
		margin: "40px",
		justifyContent: "center",
		display: "flex",
	},
	typography: {
		fontSize: "20px",
	},
	subLoaderContainer: {
		height: "25%",
		flexDirection: "column",
	},
	subLoaderError: {
		color: colors.primary,
		justifyContent: "center",
		display: "flex",
	},
	subLoaderMessage: {
		color: colors.mediumDarkGray,
		justifyContent: "center",
		display: "flex",
	},
	errorIcon: {
		fontSize: "40px",
		color: colors.red,
	},
	infoIcon: {
		fontSize: "40px",
		color: colors.charcoalGray,
	},
	errorMessage: {
		fontSize: "15px",
		color: colors.red,
	},
	infoMessage: {
		fontSize: "15px",
		color: colors.charcoalGray,
	},
}));

export default AppStyle;
